import { BsLayersFill } from '@react-icons/all-files/bs/BsLayersFill.js';
import { BsStars } from '@react-icons/all-files/bs/BsStars.js';
import { CgSidebarOpen } from '@react-icons/all-files/cg/CgSidebarOpen.js';
import { CgSidebarRight } from '@react-icons/all-files/cg/CgSidebarRight.js';
import { FaChevronDown } from '@react-icons/all-files/fa/FaChevronDown.js';
import { FaRedditSquare } from '@react-icons/all-files/fa/FaRedditSquare.js';
import { FaSalesforce } from '@react-icons/all-files/fa/FaSalesforce.js';
import { FaSlack } from '@react-icons/all-files/fa/FaSlack.js';
import { FaTelegram } from '@react-icons/all-files/fa/FaTelegram.js';
import { FaSquareXTwitter } from '@react-icons/all-files/fa6/FaSquareXTwitter.js';
import { MdAdd } from '@react-icons/all-files/md/MdAdd.js';
import { MdCheck } from '@react-icons/all-files/md/MdCheck.js';
import { MdClose } from '@react-icons/all-files/md/MdClose.js';
import { MdEmail } from '@react-icons/all-files/md/MdEmail.js';
import { MdErrorOutline } from '@react-icons/all-files/md/MdErrorOutline.js';
import { MdHelpOutline } from '@react-icons/all-files/md/MdHelpOutline.js';
import { MdInfoOutline } from '@react-icons/all-files/md/MdInfoOutline.js';
import { MdLanguage } from '@react-icons/all-files/md/MdLanguage.js';
import { MdLink } from '@react-icons/all-files/md/MdLink.js';
import { MdMoreVert } from '@react-icons/all-files/md/MdMoreVert.js';
import { MdOutlineThumbDown } from '@react-icons/all-files/md/MdOutlineThumbDown.js';
import { MdOutlineThumbUp } from '@react-icons/all-files/md/MdOutlineThumbUp.js';
import { MdOutlineWarningAmber } from '@react-icons/all-files/md/MdOutlineWarningAmber.js';
import { MdPerson } from '@react-icons/all-files/md/MdPerson.js';
import { MdPhone } from '@react-icons/all-files/md/MdPhone.js';
import { MdShare } from '@react-icons/all-files/md/MdShare.js';
import { PiTabsFill } from '@react-icons/all-files/pi/PiTabsFill.js';
import { RxExternalLink } from '@react-icons/all-files/rx/RxExternalLink.js';
import Bluesky from './icons/Bluesky.js';
import Bolt from './icons/Bolt.js';
import BoltWithOutline from './icons/BoltWithOutline.js';
import BoltWithS from './icons/BoltWithS.js';
import Citizen from './icons/Citizen.js';
import DarkWeb from './icons/DarkWeb.js';
import IncidentStream from './icons/IncidentStream.js';
import Nextdoor from './icons/Nextdoor.js';
import PrivateIncident from './icons/PrivateIncident.js';
import ProMed from './icons/ProMed.js';
import WebAlertStream from './icons/WebAlertStream.js';
import Weibo from './icons/Weibo.js';

const iconMap = {
    /* Standard icons */
    add: MdAdd,
    check: MdCheck,
    chevronDown: FaChevronDown,
    close: MdClose,
    email: MdEmail,
    error: MdErrorOutline,
    externalLink: RxExternalLink,
    info: MdInfoOutline,
    link: MdLink,
    mapSettings: BsLayersFill,
    more: MdMoreVert,
    person: MdPerson,
    phone: MdPhone,
    reddit: FaRedditSquare,
    share: MdShare,
    salesforce: FaSalesforce,
    slack: FaSlack,
    sidebarExpand: CgSidebarOpen,
    sidebarCollapse: CgSidebarRight,
    stars: BsStars,
    tabs: PiTabsFill,
    telegram: FaTelegram,
    thumbDown: MdOutlineThumbDown,
    thumbUp: MdOutlineThumbUp,
    twitter: FaSquareXTwitter,
    unknown: MdHelpOutline,
    warning: MdOutlineWarningAmber,
    web: MdLanguage,
    x: FaSquareXTwitter,
    /* Custom icons */
    bluesky: Bluesky,
    bolt: Bolt,
    boltWithOutline: BoltWithOutline,
    boltWithS: BoltWithS,
    citizen: Citizen,
    darkweb: DarkWeb,
    incidentStream: IncidentStream,
    nextdoor: Nextdoor,
    privateIncident: PrivateIncident,
    promed: ProMed,
    samdesk: BoltWithOutline,
    webAlertStream: WebAlertStream,
    weibo: Weibo,
};

export { iconMap };
//# sourceMappingURL=iconMap.js.map
